// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pow from "./lib/Pow.js";
import * as Admin from "./components/Admin.js";
import * as Queue from "./components/Queue.js";
import * as React from "react";
import * as Ticket from "./components/Ticket.js";
import * as Display from "./components/Display.js";
import * as Landing from "./components/Landing.js";
import * as QRUtils from "./lib/QRUtils.js";
import * as Storage from "./lib/Storage.js";
import * as Dispenser from "./components/Dispenser.js";
import * as GunHelpers from "./lib/GunHelpers.js";
import * as ServedScreen from "./components/ServedScreen.js";
import * as JsxRuntime from "react/jsx-runtime";

function parseRoute(hash) {
  let h = hash === "" ? "#/" : hash;
  if (h.startsWith("#/q/")) {
    let storeId = h.slice(4, 100);
    return {
      TAG: "CustomerQueue",
      _0: storeId
    };
  }
  if (h.startsWith("#/admin/")) {
    let adminId = h.slice(8, 100);
    return {
      TAG: "AdminPanel",
      _0: adminId
    };
  }
  if (!h.startsWith("#/display/")) {
    return "Landing";
  }
  let storeId$1 = h.slice(10, 100);
  return {
    TAG: "DisplayScreen",
    _0: storeId$1
  };
}

function App$Router(props) {
  let match = React.useState(() => parseRoute(window.location.hash));
  let setRoute = match[1];
  let route = match[0];
  React.useEffect(() => {
    let onHashChange = param => setRoute(param => parseRoute(window.location.hash));
    window.addEventListener("hashchange", onHashChange);
    return () => {
      window.removeEventListener("hashchange", onHashChange);
    };
  }, []);
  if (typeof route !== "object") {
    return JsxRuntime.jsx(Landing.make, {});
  }
  switch (route.TAG) {
    case "CustomerQueue" :
      return JsxRuntime.jsx(Queue.make, {
        storeId: route._0
      });
    case "AdminPanel" :
      return JsxRuntime.jsx(Admin.make, {
        adminId: route._0
      });
    case "DisplayScreen" :
      return JsxRuntime.jsx(Display.make, {
        storeId: route._0
      });
  }
}

let Router = {
  make: App$Router
};

function App$App(props) {
  return JsxRuntime.jsx(App$Router, {});
}

let App = {
  make: App$App
};

function init() {
  Storage.expose();
  Pow.expose();
  GunHelpers.expose();
  QRUtils.expose();
  Ticket.expose();
  Dispenser.expose();
  ServedScreen.expose();
  Landing.expose();
  Queue.expose();
  Admin.expose();
  Display.expose();
  let mountApp = (function(container) {
      var h = window.preact.h;
      var render = window.preact.render;
      var useState = window.preactHooks.useState;
      var useEffect = window.preactHooks.useEffect;
      var html = window.htm.bind(h);
      window.html = html;
      
      function Router() {
        var routeState = useState(window.location.hash || '#/');
        var route = routeState[0];
        var setRoute = routeState[1];
        
        useEffect(function() {
          var onHashChange = function() {
            setRoute(window.location.hash || '#/');
          };
          window.addEventListener('hashchange', onHashChange);
          return function() { 
            window.removeEventListener('hashchange', onHashChange); 
          };
        }, []);
        
        if (route.startsWith('#/q/')) {
          var storeId = route.slice(4);
          return h(window.Queue, { storeId: storeId });
        }
        
        if (route.startsWith('#/admin/')) {
          var adminId = route.slice(8);
          return h(window.Admin, { adminId: adminId });
        }
        
        if (route.startsWith('#/display/')) {
          var storeId = route.slice(10);
          return h(window.Display, { storeId: storeId });
        }
        
        return h(window.Landing, {});
      }
      
      render(h(Router, {}), container);
    });
  let container = document.getElementById("app");
  if (container == null) {
    console.error("Could not find #app element");
  } else {
    mountApp(container);
    console.log("Take a Number app initialized");
  }
}

init();

export {
  parseRoute,
  Router,
  App,
  init,
}
/*  Not a pure module */
